module.exports = __webpack_public_path__ + "static/media/icon-conlicitacao.7a98fee8.svg";